<button
  (click)="this.call()"
  class="h-full w-full rounded flex items-center justify-center gap-2 border border-gris-3 px-2 text-sm transition"
  [class.border-vert-1]="this.theme() === 'light' && this.enabled() && this._state() !== 'loading'"
  [class.hover:bg-vert-2]="this.theme() === 'light' && this._state() === 'default' && this.enabled()"
  [class.bg-vert-1]="this.theme() === 'light' && this.enabled() && this._state() !== 'loading'"
  [class.bg-orange-1]="this._state() === 'failed'"
  [class.border-orange-1]="this._state() === 'failed'"
  [class.text-white]="this.enabled() && this._state() !== 'loading'"

  [class.fg-gris-3]="!this.enabled()"
  [class.cursor-not-allowed]="!this.enabled()"
>
  <span
    class="material-icons material-symbols-outlined"
    [innerText]="this.getIconFromState()"
    [class.animate-spin]="this._state() === 'loading'"
  >

  </span>

  <p class="text-xs font-semibold" [innerText]="this._displayedLabel()">
</button>
